import { PropsWithChildren, useCallback, useRef } from 'react';
import { twMerge } from 'tailwind-merge';
import { useModalContext } from 'src/hooks/useModalContext';
import { CloseModal } from './CloseModal';

export const ModalWrapper = ({
  onClose,
  children,
  isTransparentBg,
  containerClassName,
  crossPosition = 'absolute',
  backdropClassName,
  showCross = true,
  className
}: PropsWithChildren<{
  onClose?: () => void;
  className?: string;
  containerClassName?: string;
  isTransparentBg?: boolean;
  crossPosition?: 'sticky' | 'absolute' | 'fixed' | 'relative';
  showCross?: boolean;
  backdropClassName?: string;
}>) => {
  const { openedModal, modalProps, closeModal } = useModalContext<{
    onClose?: () => void;
  }>();
  const contentRef = useRef<HTMLDivElement | null>(null);

  const handleClose = useCallback(() => {
    closeModal(); // основная функция которая закрывает модальное окно в контексте модальных окон
    onClose?.(); // функция переданная из компонента конкретного модального окна
    modalProps?.onClose?.(); // функция-коллбэк переданная в момент открытия модального окна
  }, [closeModal, modalProps, onClose]);

  return (
    <div
      data-role="blackBackgroundFullscreenPlaceholder"
      className={twMerge(
        'flex items-center justify-center',
        'left-0 top-0 fixed z-[900] w-screen h-full max-h-screen',
        openedModal ? 'translate-y-[0px]' : 'translate-y-[-100%]',
        isTransparentBg ? '' : 'bg-m_shadow',
        backdropClassName
      )}>
      <div
        ref={contentRef}
        key="modalContentWrapper"
        data-role="modalContentWrapper"
        className={twMerge(
          'modal-wrapper max-h-[94dvh] relative w-full h-auto overflow-y-auto overflow-x-hidden self-center',
          isTransparentBg ? '' : 'rounded-lg border-[3px] border-mg_border bg-lm_bg',
          containerClassName,
          className
        )}>
        {showCross && (
          <CloseModal
            onClose={handleClose}
            className={twMerge('top-2 w-4 h-4 inline-block right-2', crossPosition)}
          />
        )}
        {children}
      </div>
    </div>
  );
};
